'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dAccepted$002dDrug$002dRequest$002dProcessed from "./app.api.-Pharmacy-App-Update$-Accepted-Drug-Request-Processed.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ as $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ };
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ as $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ };
$h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype = $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype;
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype.toString__T = (function() {
  return "AcceptedDrugRequestProcessed";
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed = (function(x$0) {
  var id$7 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dAccepted$002dDrug$002dRequest$002dProcessed.$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed(id$7);
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed(p);
});
var $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$, "app.api.PharmacyAppUpdate$AcceptedDrugRequestProcessed$", ({
  Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ as $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ };
var $n_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$;
function $m_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$)) {
    $n_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ = new $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$;
}
export { $m_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ as $m_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-Accepted-Drug-Request-Processed$.js.map
